import { render, staticRenderFns } from "./AlcanceProductoDialog.vue?vue&type=template&id=cc16b870"
import script from "./AlcanceProductoDialog.vue?vue&type=script&lang=js"
export * from "./AlcanceProductoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports